import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../../config/authAxios";
import apiRoutes from "../../apiConfigs";

export const eventSettingDeleteApi = createAsyncThunk(
  "eventModuleSetting/delete",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.publicapiAction(`events_setting`, 1), { data });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const eventSettingDeleteSlice = createSlice({
  name: "event setting delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(eventSettingDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(eventSettingDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(eventSettingDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const eventSettingDeleteReducer = eventSettingDeleteSlice.reducer;
